export default [
  {
    path: '/project',
    name: 'list-project',
    component: () => import('@/views/project/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.project',
      resource: 'manage-project',
      action:'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listProject',
          active: true,
        },
      ],
    }
  },
  // {
  //   path: '/project/:projectId/department',
  //   name: 'list-project-department',
  //   component: () => import('@/views/department/List.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.project',
  //     resource: 'manage-project',
  //     navActiveLink: 'list-project',
  //     action: 'read',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.project',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/project/create',
    name: 'create-project',
    component: () => import('@/views/project/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.project',
      navActiveLink: 'list-project',
      resource: 'manage-project',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listProject',
          to: { name: 'list-project' }
        },
        {
          text: 'breadcrumb.createProject',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project/:id/update',
    name: 'update-project',
    component: () => import('@/views/project/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.project',
      navActiveLink: 'list-project',
      resource: 'manage-project',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listProject',
          to: { name: 'list-project' }
        },
        {
          text: 'breadcrumb.updateProject',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/project/:projectId/department/create',
  //   name: 'create-project-department',
  //   component: () => import('@/views/department/Create.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.department',
  //     navActiveLink: 'list-project',
  //     resource: 'manage-department',
  //     action: 'create',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-department' },
  //       },
  //       {
  //         text: 'breadcrumb.create_department',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/project/:projectId/department/:id/update',
  //   name: 'update-project-department',
  //   component: () => import('@/views/department/Update.vue'),
  //   meta: {
  //     pageTitle: 'breadcrumb.department',
  //     navActiveLink: 'list-project',
  //     resource: 'manage-department',
  //     action: 'update',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list_department',
  //         to: { name: 'list-project-department' },
  //       },
  //       {
  //         text: 'breadcrumb.update_department',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/project/:projectId/department/:departmentId/employee',
  //   name: 'list-project-employee',
  //   component: () => import('@/views/department/WorkingSchedule.vue'),
  //   meta: {
  //       pageTitle: 'breadcrumb.project',
  //       resource: 'manage-department',
  //       navActiveLink: 'list-project',
  //       action: 'read',
  //       breadcrumb: [
  //         {
  //           text: 'breadcrumb.list_department',
  //           to: { name: 'list-project-department' },
  //         },
  //         {
  //           text: 'breadcrumb.list_employee',
  //           active: true,
  //         },
  //       ],
  //   },
  // },
]